import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FeatureFlagBypassInterceptor } from './infraestructure/helpers/http/feature-flag-bypass.interceptor';
import { JwtInterceptor } from './infraestructure/helpers/http/jwt.interceptor';
import { ErrorInterceptor } from './infraestructure/helpers/http/error.interceptor';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AlertModule } from './UI/view-models/alert/alert.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedCrossellModule } from './UI/common/modules/shared-crossell/shared-crossell.module';
import { SharedModule } from './UI/common/modules/shared/shared.module';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { NgOptimizedImage } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    AlertModule,
    HttpClientModule,
    ReactiveFormsModule,
    RxReactiveFormsModule,
    SharedCrossellModule,
    SharedModule,
    NgOptimizedImage,
    BrowserAnimationsModule,
    RecaptchaV3Module,
    NgSelectModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: FeatureFlagBypassInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.RecaptchaV3KeySite,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
